import { FC, useCallback } from 'react';

import { EnvironmentDeploymentType } from '@/__generated__/graphql';
import { useFilterContext } from '@/context/FilterProvider';
import { useSearchFacets } from '@/context/SearchFacetsProvider';
import { BaseFilterToggle } from './BaseFilterToggle';
import { ClearSelectAllButton } from './ClearSelectAllButton';
import { FilterSection } from './FilterSection';

export type EnvironmentTypeFiltersProps = {};

const SELECTION_LIST = [
  { label: 'Production', value: EnvironmentDeploymentType.Production },
  { label: 'Staging', value: EnvironmentDeploymentType.Staging },
  // FUTURE TODO: {label: 'Development', value: EnvironmentDeploymentType.Development
];

export const EnvironmentTypeFilters: FC<EnvironmentTypeFiltersProps> = () => {
  const filterCtx = useFilterContext();
  const { aggregations } = useSearchFacets();

  const environmentTypes = filterCtx.filters?.environmentTypes;

  const handleToggle = useCallback(
    (field: EnvironmentDeploymentType) => {
      const isAdding = !environmentTypes?.includes(field);
      filterCtx.updateFilters({ environmentTypes: [field] }, isAdding);
    },
    [filterCtx, environmentTypes],
  );
  return (
    <FilterSection title="dbt Environment" enableExpansion isDefaultExpanded>
      <ul className="mt-2">
        {SELECTION_LIST.map((selection) => (
          <li key={selection.value}>
            <BaseFilterToggle
              isChecked={environmentTypes?.includes(selection.value)}
              onToggle={() => {
                handleToggle(selection.value);
              }}
              checkBoxTestId={`environment-type-${selection.label.toLowerCase()}-checkbox`}
              count={aggregations?.environmentType?.[selection.value]}
            >
              {selection.label}
            </BaseFilterToggle>
          </li>
        ))}
      </ul>
      <ClearSelectAllButton
        type="environmentTypes"
        selectedList={environmentTypes}
        selectionList={SELECTION_LIST}
      />
    </FilterSection>
  );
};
